// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flow-panel-time--header h5{margin-bottom:0}.flow-panel-time--header p{margin-top:0;color:#9e9ead}", ""]);
// Exports
module.exports = exports;
